export default __webpack_public_path__ + "static/melos-studio-e9462d4cf2b5e5e9f790db3d2f9cd392.png";